var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiceBlue3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-300 -105) translate(48 105) translate(252)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#7090FF",
    fillOpacity: 0.3,
    rx: 28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 57,
    fill: "#7090FF",
    stroke: "#96ACF9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 77.5,
    r: 8.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 60.5,
    r: 8.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 42.5,
    r: 8.5,
    fill: "#FFF"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiceBlue3);
export default __webpack_public_path__ + "static/media/dice-blue-3.067ae2288184ec154b4749d69655f676.svg";
export { ForwardRef as ReactComponent };